export function clone(obj) {
  var E = JSON.stringify(obj);
  return JSON.parse(E);
}

// 验证手机号码
export const validatPhone =
  /^(^(([0\+]\d{2,3}-)?(0\d{2,3})-)(\d{7,8})(-(\d{3,}))?$)|(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/;
//验证密码
export const validatePassword = /^(?=.*\d)(?=.*[a-zA-Z]).{5,20}$/;

export function valueToLabel(list,value) {
  if (!list) return value;
  let item = list.find((i) => i.value == value);
  return item ? item.label : "";
}
